import { Info } from 'lucide-react';
import styled from 'styled-components';

export const TooltipTriggerWrapper = styled.button.attrs({
  type: 'button',
  className:
    'flex shrink-0 p-0 m-0 border-none bg-transparent cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-sm',
})``;

export const InclusionInfoIcon = styled(Info).attrs({
  className: 'size-4 text-muted-foreground',
})``;
